import React from 'react';
import { Card } from 'react-bootstrap';

import { numberFormat } from '../../../../utils';
import { translate } from 'react-i18next';

class ItemFinance extends React.PureComponent {

  render() {
    const { resource, className, t } = this.props;

    return (
      <Card className={className}>
        <Card.Body>
          <table className="table table-borderless">
            <thead>
              <tr>
                <th>{t('txt-label-items')}</th>
                {resource &&
                  resource.Head &&
                  !!resource.Head.length &&
                  resource.Head.map((item, index) => (
                    <th key={'header_' + index} className="fz-14 content-read">
                      {item.TermCode === 'N'
                        ? item.YearPeriod
                        : item.TermCode + ' ' + item.YearPeriod}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {resource.Content &&
                !!resource.Content.length &&
                resource.Content.map((item, index) => (
                  <tr key={'body_' + index}>
                    <td className="fz-14 content-read">{item.Name}</td>
                    <td className="fz-14 text-right">
                      {numberFormat(item.Value1, 2)}
                    </td>
                    <td className="fz-14 text-right">
                      {numberFormat(item.Value2, 2)}
                    </td>
                    <td className="fz-14 text-right">
                      {numberFormat(item.Value3, 2)}
                    </td>
                    <td className="fz-14 text-right">
                      {numberFormat(item.Value4, 2)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Card.Body>
      </Card>
    );
  }
}

export default translate('translations')(ItemFinance);
